<template xmlns:v-on="http://www.w3.org/1999/xhtml">
  <div id="templatePane">
    <div class="hero-section shade-40">
      <div class="hero-section-text row column">
        <h1>Hey, great news - you're good to go!</h1>
      </div>
    </div>
    <section id="mainContent" class="row">
      <div class="medium-8 column">
        <h2>You're already set up on Workplace</h2>
        <p>It looks like you're already set up, so just head straight over to <a
            href="https://bt.workplace.com">bt.workplace.com</a> or <a
            href="https://openreach.workplace.com">openreach.workplace.com</a> to get started. Workplace is at its best
          when it's available on the move, so why not download the app?</p>

        <h2>How do I access Workplace?</h2>
        <p>You can use Workplace from any of your work or personal devices. Here's how.</p>
        <ul>
          <li>From an Android device, <a target="_blank"
              href="https://play.google.com/store/apps/details?id=com.facebook.work">download "Workplace by Facebook" from
              Google Play</a>. Need some <a href="/help-25849">help?</a></li>
          <li>From an iPhone or iPad, <a target="_blank"
              href="https://itunes.apple.com/gb/app/workplace-by-facebook/id944921229">download "Workplace by Facebook" in
              the App Store</a>. Need some <a href="/help-25852">help?</a></li>
          <li>From a Windows phone, use your favourite web browser to visit <a
              href="https://bt.workplace.com">bt.workplace.com</a> or <a
              href="https://openreach.workplace.com">openreach.workplace.com</a>. There's no app available.</li>
          <li>From any PC or Mac, use your favourite web browser to visit <a
              href="https://bt.workplace.com">bt.workplace.com</a> or <a
              href="https://openreach.workplace.com">openreach.workplace.com</a></li>
          <li>From an Openreach iPhone, you'll need to <a target="_blank" href="/help-20266">install the app from the
              Blackberry store</a></li>
        </ul>

        <h2>Need some help or support?</h2>
        <p>If you've access to the BT intranet we've got <a
            href="https://fixit.bt.com/pages/browsebysubject.aspx?contentcenter=Workplace%20by%20Facebook">lots of
            articles on FixIT</a> to help you get the most from Workplace.</p>
        <p>Not got access? Don't worry - we've got you covered with some <a href='/help'>handy help guides</a>.</p>

      </div>
      <div v-if="!submitted" class="medium-4 column">
        <h2>Please tell us how we've done</h2>
        <form id="feedback-form" class="vue-form" data-abide novalidate @submit.prevent="submit">
          <fieldset id="feedback-rating-id">
            <legend>On a scale of 1 to 10 (where 1 is 'very unlikely' and 10 'very likely'), how likely would you be to
              recommend this sign-up experience to a colleague?</legend>
            <div role="radiogroup" class="nps clearfix" id="radio-inline-id">
              <div>
                <input id="feedback-rado-1" @change="revalidate" name="feedback-rado" v-model="feedback.rating"
                  type="radio" value="1" required />
                <label for="feedback-rado-1">
                  1
                </label>
              </div>
              <div>
                <input id="feedback-rado-2" @change="revalidate" name="feedback-rado" v-model="feedback.rating"
                  type="radio" value="2" />
                <label for="feedback-rado-2">
                  2
                </label>
              </div>
              <div>
                <input id="feedback-rado-3" @change="revalidate" name="feedback-rado" v-model="feedback.rating"
                  type="radio" value="3" />
                <label for="feedback-rado-3">
                  3
                </label>
              </div>
              <div>
                <input id="feedback-rado-4" @change="revalidate" name="feedback-rado" v-model="feedback.rating"
                  type="radio" value="4" />
                <label for="feedback-rado-4">
                  4
                </label>
              </div>
              <div>
                <input id="feedback-rado-5" @change="revalidate" name="feedback-rado" v-model="feedback.rating"
                  type="radio" value="5" />
                <label for="feedback-rado-5">
                  5
                </label>
              </div>
              <div>
                <input id="feedback-rado-6" @change="revalidate" name="feedback-rado" v-model="feedback.rating"
                  type="radio" value="6" />
                <label for="feedback-rado-6">
                  6
                </label>
              </div>
              <div>
                <input id="feedback-rado-7" @change="revalidate" name="feedback-rado" v-model="feedback.rating"
                  type="radio" value="7" />
                <label for="feedback-rado-7">
                  7
                </label>
              </div>
              <div>
                <input id="feedback-rado-8" @change="revalidate" name="feedback-rado" v-model="feedback.rating"
                  type="radio" value="8" />
                <label for="feedback-rado-8">
                  8
                </label>
              </div>
              <div>
                <input id="feedback-rado-9" @change="revalidate" name="feedback-rado" v-model="feedback.rating"
                  type="radio" value="9" />
                <label for="feedback-rado-9">
                  9
                </label>
              </div>
              <div>
                <input id="feedback-rado-10" @change="revalidate" name="feedback-rado" v-model="feedback.rating"
                  type="radio" value="10" />
                <label for="feedback-rado-10">
                  10
                </label>
              </div>
            </div>
            <span class="form-error" data-form-error-for="feedback-rado-1" id="feedback-rating-error">
              Go on, please give us a rating. It'll help us improve.
            </span>

          </fieldset>

          <div>
            <label for="feedback-comment">Tell us why you scored it that way</label>
            <textarea id="feedback-comment" @change="revalidate" :required="(feedback.rating < 10) ? true : false" rows="5"
              maxlength="1000" aria-errormessage="feedback-comment-error" v-model="feedback.comment"></textarea>
            <span class="form-error" id="feedback-comment-error">
              We'd really appreciate it if you could provide a brief comment
            </span>
          </div>
          <button class="button" type="submit">Send us your feedback</button>
        </form>
        <div data-abide-error class="alert" v-if="errorSubmitting">
          Oops, we've not been able to submit your feedback. Please try again later.
        </div>
      </div>
      <div v-else>
        <h2>Thanks for the feedback</h2>
        <p>We really appreciate you letting us know what you think.</p>
      </div>
    </section>
  </div>
</template>

<style>
#feedback-rating-id {
  display: inline-block;
}

.nps div {
  float: left;
  clear: none;
}

.nps label {
  margin-left: 2px;
  margin-right: 2px;
  width: 2rem;
  height: 2rem;
  border: 2px solid #666;
  border-radius: 50%;
  text-align: center;
  color: #666;
}

@media screen and (max-width: 39.9375em) {
  .nps label {
    margin-left: 1px;
    margin-right: 1px;
  }
}

.nps div:first-of-type label {
  margin-left: 0;
}

.nps div:last-of-type label {
  margin-right: 0;
}

.nps [type=radio] {
  position: absolute;
  opacity: 0;
  width: 0;
  height: 0;
}

.nps [type=radio]:checked+label {
  background-color: #5514b4;
  border-color: #5514b4;
  color: #fff;
}
</style>

<script>
var ES6Promise = require("es6-promise")
ES6Promise.polyfill()
import Vue from 'vue'
import axios from 'axios'
import VueAxios from 'vue-axios'
Vue.use(VueAxios, axios)
import { fixitContentCentre } from '../commonError'
import api from '../../api'
import authentication from '../../authentication'

export default {
  name: 'ErrorAlreadyInvited',
  title: "Workplace - You're already invited",
  data: function () {
    return {
      workplaceUrl: "",
      fixitContentCentre: fixitContentCentre,
      feedback: {
        rating: '',
        comment: ''
      },

      errorSubmitting: false,
      submitted: false
    };
  },

  methods: {
    revalidate: function () {
      this.$nextTick(() => {
        // Revalidate form
        if ((this.feedback.rating === "10")) {
          const formEl = document.getElementById('feedback-form')
          $(formEl).foundation('validateForm')
        }
      })
      this.errorSubmitting = false;
    },
    submit: function () {
      this.errorSubmitting = false;
      // Revalidate form
      const formEl = document.getElementById('feedback-form')
      $(formEl).foundation('validateForm')
      if ($(formEl).find('.form-error.is-visible').length || $(formEl).find('.is-invalid-label').length) {
        return false;
      }

      authentication.getCachedToken().then(response => {
        var token = response.rawIdToken;
        api.submitFeedback(this.feedback, token)
          .then(response => {
            this.submitted = true;
          })
          .catch(error => {
            this.errorSubmitting = true;
            this.submitted = false;
          });
      });
    }
  },
  mounted() {
    // Specify a custom validation function
    Foundation.Abide.defaults.validators['comment'] = this.validateComments
    // Re-create Abide validation
    this.abide = new Foundation.Abide($('[data-abide]'))
  },
  destroyed() {
    // eslint-disable-next-line
    if (typeof this.abide !== 'undefined') {
      this.abide.destroy()
    }
  }
}
</script>
